import React from "react";

import { SkeletonBox } from "~/components/skeleton/box";
import type { HealthStateValue } from "~/models/dto";
import { cx } from "~/tools/class-variance";
import type { Record } from "~/tools/record";

import { healthStateStyle } from "../../../common/functions";
import type { Api } from "../../../common/openapi";

export type HealthStateCircleSize = "small" | "medium" | "large";

export interface HealthStateCircleProps {
	/**
	 * Renders a skeleton when `undefined`
	 */
	state: undefined | Api.HealthStateValue | HealthStateValue;
	size?: HealthStateCircleSize;
	className?: string;
	css?: never;
	tw?: never;
}

const sizeMap = {
	small: cx("size-2"),
	medium: cx("size-3"),
	large: cx("size-4"),
} satisfies Record<HealthStateCircleSize>;

export const HealthStateCircle: React.FC<HealthStateCircleProps> = ({ className, state, size = "large" }) => (
	<SkeletonBox
		className={cx("shrink-0 rounded-full", sizeMap[size], className)}
		data-testid={`sts-state-circle-${state?.toString() ?? "skeleton"}`}
		style={state ? healthStateStyle(state) : undefined}
		when={state}
	/>
);
